import { render } from "./ActionHistory.vue?vue&type=template&id=1b646bfa"
import script from "./ActionHistory.vue?vue&type=script&lang=js"
export * from "./ActionHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__